import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d73ab60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-mx-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "p-text-center top-bar" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.0rem"},
    class: "pi pi-check-circle"
  }),
  /*#__PURE__*/_createTextVNode(" Manage Permissions "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "Please logout and login to apply new privileges")
], -1))
const _hoisted_5 = { class: "group-header" }
const _hoisted_6 = { class: "p-grid p-px-2" }
const _hoisted_7 = { class: "p-field-checkbox" }
const _hoisted_8 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Dropdown, {
              style: {"width":"15rem"},
              modelValue: _ctx.selectedRoleID,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRoleID) = $event)),
              options: _ctx.roles,
              optionLabel: "name",
              optionValue: "id",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList(0)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              icon: "pi pi-save",
              class: "p-button-success",
              onClick: _ctx.savePermissions,
              label: "Save",
              disabled: _ctx.selectedRoleID == 0
            }, null, 8, ["onClick", "disabled"])
          ])
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedPermissions, (group, typeId) => {
          return (_openBlock(), _createElementBlock("div", { key: typeId }, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(group.type), 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (p) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "p-col-3",
                  key: p.id
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Checkbox, {
                      id: p.id,
                      modelValue: _ctx.checkedPermission,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedPermission) = $event)),
                      value: p.id
                    }, null, 8, ["id", "modelValue", "value"]),
                    _createElementVNode("label", {
                      for: p.id
                    }, _toDisplayString(p.title), 9, _hoisted_8)
                  ])
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}